/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.students.scheduling.teacher-rooms'},
});

const TeacherRoomsItem = () => (
  <RouteLinkItem
    route="midas/students/scheduling/teacher-rooms"
    title={messages.title}
  />
);

export default TeacherRoomsItem;
